import registerDiagnosticsInfo from './utils/registerDiagnosticsInfo';
import initializeServiceRequestDiagnostics from './initializeServiceRequestDiagnostics';
import registerFindMeetingTimesDiagnostics from './utils/registerFindMeetingTimesDiagnostics';

export default function initializeDefaultDiagnostics() {
    registerDiagnosticsInfo();
    initializeServiceRequestDiagnostics();
    registerFindMeetingTimesDiagnostics();
}
